import { useForm } from "react-weaver";
import React from "react";
import * as yup from "yup";

import { Block } from "kanopi-components/Block";
import { Button } from "kanopi-components/Button";
import { FixedFooter } from "kanopi-components/Sticky/FixedFooter";
import { Form } from "kanopi-components/Form";
import { Input, FormControl } from "kanopi-components/Input";
import { HeadingLarge, ParagraphMedium } from "kanopi-components/typography";
import { Kontainer } from "kanopi-components/Layout/Kontainer";
import { Sektion } from "kanopi-components/Layout/Sektion";
import { SidePadder } from "kanopi-components/Layout/SidePadder";

import { useNavigate } from "@reach/router";

import { handleErrorDisplay } from "kw/util/utils";
import { usePasswordResetRequest } from "../hooks/usePasswordResetRequest";

export function PasswordResetRequestPage() {
  const navigate = useNavigate();
  const passwordResetRequest = usePasswordResetRequest();
  const { fieldProps, submit, loading, errors } = useForm({
    onSubmit: passwordResetRequest,
    validator: yup.object().shape({
      email: yup.string().email().required().label("Your email address"),
    }),
  });
  const handleSubmit = async () => {
    try {
      await submit();
      navigate("/password-reset/request/success", {
        state: { email: fieldProps?.email?.value },
      });
    } catch (exc) {
      handleErrorDisplay(exc);
    }
  };

  return (
    <>
      <Form>
        <SidePadder>
          <HeadingLarge marginBottom={0} center>
            Forgot your password?
          </HeadingLarge>

          <Kontainer>
            <Sektion>
              <Block maxWidth="28rem" margin="auto">
                <ParagraphMedium center marginBottom="scale1000" marginTop={0}>
                  Please enter your email address below. We’ll send you a link to reset
                  your password.
                </ParagraphMedium>
                <FormControl label="Your email address" error={errors?.email}>
                  <Input {...fieldProps.email} />
                </FormControl>
              </Block>
            </Sektion>
          </Kontainer>
        </SidePadder>

        <FixedFooter>
          <Sektion>
            <Block display="flex" justifyContent="center">
              <Button
                type="submit"
                kind={Button.KIND.primary}
                wide
                onClick={handleSubmit}
                isLoading={loading}
                disabled={!fieldProps.email.value.length || !!errors?.email?.length}
              >
                Send reset email
              </Button>
            </Block>
          </Sektion>
        </FixedFooter>
      </Form>
    </>
  );
}
